import { render, staticRenderFns } from "./TellerToTellerSuper.vue?vue&type=template&id=a1f1c088&scoped=true"
import script from "./TellerToTellerSuper.vue?vue&type=script&lang=js"
export * from "./TellerToTellerSuper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f1c088",
  null
  
)

export default component.exports